const MAX_ENTRIES = 50;
const buffer = [];

function patch(level, original) {
  return (...args) => {
    buffer.push({
      level,
      message: args.map(a => {
        if (typeof a !== 'object' || a === null) return String(a);
        try { return JSON.stringify(a); } catch { return String(a); }
      }).join(' '),
      ts: Date.now(),
    });
    if (buffer.length > MAX_ENTRIES) buffer.shift();
    original.apply(console, args);
  };
}

console.log   = patch('log',   console.log);
console.warn  = patch('warn',  console.warn);
console.error = patch('error', console.error);

export function getConsoleLogs() {
  return [...buffer];
}
